/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Types_Ingest_FailedInputs */

const es_admin_traces_types_ingest_failed = /** @type {(inputs: Admin_Traces_Types_Ingest_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo de ingestión`)
};

const en_admin_traces_types_ingest_failed = /** @type {(inputs: Admin_Traces_Types_Ingest_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingest failed`)
};

/**
* | output |
* | --- |
* | "Ingest failed" |
*
* @param {Admin_Traces_Types_Ingest_FailedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_types_ingest_failed = /** @type {((inputs?: Admin_Traces_Types_Ingest_FailedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Types_Ingest_FailedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_types_ingest_failed(inputs)
	return en_admin_traces_types_ingest_failed(inputs)
});
export { admin_traces_types_ingest_failed as "admin.traces.types.ingest_failed" }